import {memo} from 'react'

/* @autogenerated optimization completed by @naverpay/optimize-svg-components */
import {SvgUniqueID} from '@naverpay/svg-manager'

import type {SVGStyleProps} from '@naverpay/svg-manager'

const IconGraphLow = memo(({width = '100%', height = '100%', viewBox = '0 0 30 30', id, style = {}}: SVGStyleProps) => (
    <SvgUniqueID id={id}>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox={viewBox}
            style={style}
            fill="none"
        >
            <rect x="4" width="9.76552" height="30" rx="2" fill="#DCDEE0" />
            <rect x="4.5" y="0.5" width="8.76552" height="29" rx="1.5" stroke="black" strokeOpacity="0.05" />
            <rect x="17.0195" y="15" width="9.76552" height="15" rx="2" fill="#F73631" />
            <rect x="17.5195" y="15.5" width="8.76552" height="14" rx="1.5" stroke="black" strokeOpacity="0.05" />
        </svg>
    </SvgUniqueID>
))

export default IconGraphLow
